// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  InstantSearch.prototype.beforeInit = function(id) {
  jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]').each(function(i) {
    if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
      var clone = jQ(this).clone();
      jQ(this).replaceWith(clone);
    }
  }); 
}





  
})();